<!--Desktop Banner-->
<ng-container *inPopulation="[populations.Default]">
  <fgb-desktop-nav-banner [pageName]="'partner.offers.page.title' | translate"></fgb-desktop-nav-banner>
</ng-container>
<ng-container *inPopulation="[populations.Club1901]">
  <fgb-desktop-nav-banner [pageName]="'partner.offers.1901.page.title' | translate"></fgb-desktop-nav-banner>
</ng-container>

<!--Mobile Navigation-->
<div class="bg-primary d-lg-none mobile-header-background"></div>

<ng-container *inPopulation="[populations.Default]">
  <fgb-mobile-nav-menu
    [pageName]="'partner.offers.page.title' | translate"
    [showHamburger]="false"
    [showWalletButton]="false"
  ></fgb-mobile-nav-menu>
</ng-container>
<ng-container *inPopulation="[populations.Club1901]">
  <fgb-mobile-nav-menu
    [pageName]="'partner.offers.1901.page.title' | translate"
    [showHamburger]="false"
    [showWalletButton]="false"
  ></fgb-mobile-nav-menu>
</ng-container>

<div class="container mobile-page-content">
  <fgb-brand-list></fgb-brand-list>
</div>
